import React, { useEffect, useState } from "react";
import NavbarHome from "../home/NavbarNew/NavbarHome";
import FootNav from "../User_Profile/Footer/Footer-nav/FootNav";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import axios from "axios";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import OrderView from "./OrderView";
// import Disputes from "../../components/product/Disputes";
import { slugify } from "../../utils";
import Disputes from "../../components/product/Disputes";

const OrdersScreen = () => {

	const { state } = useLocation();
	const navigate = useNavigate();
	const { item } = state !== null ? state : { id: null };
	const [orders, setOrders] = useState([]);
	const userData = useSelector((state) => state?.auth?.user?.user);
	const [activeOrder, setActiveOrder] = useState(null);
	const [detailOrder, setDetailOrder] = useState(false);

	const getOrders = () => {

		let data = JSON.stringify({
			id: userData?._id,
		});

		var config = {
			method: "post",
			url: Server2 + "/orders/get-by-user",
			headers: { "Content-Type": "application/json" },
			data: data,
		};
		axios(config)	
			.then((response) => {
				setOrders(response.data);
				if (item?.id !== undefined) {
					const order = response.data.find(
						(order) => order._id === item._id
					);
					setActiveOrder(order)
				} else
					setActiveOrder(response.data[0])
			})
			.catch((err) => {
				console.log(err, "error");
			});
	}

	useEffect(() => {
		getOrders();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="orders-wrapper d-flex flex-column">
			<NavbarHome />
			<div className="container-fluid px-4 pb-3 d-flex flex-column" style={{ maxWidth: 1200, minHeight: "82dvh", overflowY: 'auto' }}>
				<div className="mt-5 mb-3">
					<div className="d-flex align-items-center gap-3 fw-bold">
						<span className="fw-bolder px-3 py-2 rounded-2 text-white" style={{ backgroundColor: '#7dba38' }}>My Orders</span>
						<p className="fw-bold  text-dark">You have made {(orders.filter(order => order.buyerOrderStatus !== 'unpaid')).length} orders from iBouge market</p>
					</div>
				</div>

				{orders === undefined ?
				<div className="d-flex justify-content-center align-items-center">
					<div
						className="spinner-border"
						role="status"
						style={{ width: "6rem", height: "6rem", color: "#6148A1" }}
					>
						<span className="sr-only">.</span>
					</div>
				</div> : orders.length > 0 ? <>
				<div className="table-responsive">
					<table className="table align-middle">
						<thead className="">
							<tr>
								<th className="ps-0"><p className="border-bottom border-dark pb-1">Sellers</p></th>
								<th className="ps-0"><p className="border-bottom border-dark pb-1">Products</p></th>
								<th className="ps-0"><p className="border-bottom border-dark pb-1">Price</p></th>
								<th className="ps-0"><p className="border-bottom border-dark pb-1">Status</p></th>
								{/* <th className=" ps-0"><p className="border-bottom border-dark pb-1">Tracking ID</p></th> */}
								<th className=""><p className="border-bottom border-dark pb-1">Action</p></th>
							</tr>
						</thead>
						<tbody>
							{orders.map((order) => ( order?.buyerOrderStatus !== 'unpaid' &&
								<tr key={order._id}>

									<td>
										{/* <AvatarGroup users={order.sellerOrders}/> */}
										{order?.sellerOrders?.map((seller, index) => (
											<div className="d-flex justify-content-start gap-2 cursor-pointer" onClick={() => navigate(`/profile/${seller?.seller?._id}/${slugify(seller?.seller?.fname)}`, { state: { item: seller?.seller?._id } })}>
												<img
													src={seller?.seller?.profile_pic}
													alt={'user.fname'}
													className="rounded-circle border border-white"
													style={{
														width: 40,
														height: 40,
														objectFit: "cover",
													}}
												/>
												<h6 className="pt-2 pb-0" style={{ maxWidth: 270, textOverflow: 'ellipsis', overflow: 'hidden' }}>
													{seller?.seller?.fname}
												</h6>
											</div>
										))}
									</td>

									<td>
										{order.items.map((item) => (
											<h6 className="lh-1 cursor-pointer" style={{ maxWidth: 270, textOverflow: 'ellipsis', overflow: 'hidden' }} onClick={() => navigate(`/product/${item?.productId}`, { state: { item: item.productId } })}>
												{item?.productName}
											</h6>
										))}
									</td>

									<td>${order?.totalAmount?.toFixed(2)}</td>

									<td>
										{order?.buyerOrderStatus}
									</td>

									{/* <td style={{maxWidth: 50, overflow: 'scroll' }}>{order._id.toUpperCase()}</td> */}

									<td>
										<center>
											<button className="btn btn-sm px-3 text-white" style={{ backgroundColor: '#7dba38' }}
												onClick={() => {
													setActiveOrder(order)
													setDetailOrder(true)
												}}
											>
												View
											</button>
										</center>
									</td>

								</tr>
							))}
						</tbody>
					</table>
				</div>

				{/* Disputes */}
				<Disputes/>
				</> : null }

			</div>

			{ detailOrder && <OrderView activeOrder={activeOrder} setActiveOrder={setActiveOrder} setDetailOrder={setDetailOrder} getOrders={()=>getOrders()} /> }

			<FootNav />
		</div>
	);
};

export default OrdersScreen;